<template>
  <v-layout row justify-center>
    <v-flex>

      <v-card flat class="ma-2 mt-4">

<v-layout column>
      <v-text-field outline hide-details readonly class="mt-4" label="Patient" @click="showPatientSearch()" v-model="patientID"></v-text-field>
      <v-menu class="mt-4" ref="menuProvider" :close-on-content-click="true" v-model="menuProvider" lazy transition="scale-transition" offset-y full-width min-width="290px">
                <v-text-field :hint="providerID" persistent-hint outline hide-details slot="activator" v-model="providerName" label="Provider"></v-text-field>
                <v-list v-if="searchResults">
                  <v-list-tile row v-for="provider in searchResults" :key="provider.npi" :provider="provider" @click="selectProvider(provider)">
                    <v-list-tile-content style="margin:5px;">
                      <v-list-tile-title>{{provider.displayNameIndividual}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{provider.displayAddressIndividual}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>

              </v-menu>

      <v-text-field class="mt-4" outline hide-details hint="mm/dd/yyyy" mask="##/##/####" persistent-hint v-model="date" label="Encounter Date"></v-text-field>
      <v-select :items="recordTypes" class="mt-4" outline required v-model="typeInput" label="Record Type" />

<v-layout  v-if="file" style="cursor:pointer"  @click="openFile(file[0])">
                <v-card class="standardCard" style="background-color:#eeeeee" flat width="100%">
                  <v-card-text class="file-card-text">
                    <v-layout v-if="file[0].originalFilename" class="file-card-title-text">
                      {{file[0].originalFilename}}
                    </v-layout>
                    <v-layout v-else class="file-card-title-text">
                      No file name
                    </v-layout>
                    <!-- <br/> -->
                    <v-layout>
                      {{file[0].id}}
                    </v-layout>
                    <v-layout v-if="file[0].patient">
                      {{file[0].patient.firstName}} {{file[0].patient.lastName}}
                    </v-layout>
                    <v-layout v-if="file[0].renderingProvider">
                      {{providerName}}
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-layout>

                    <v-layout row>
            <v-spacer></v-spacer>
            <v-btn @click="uploadRecord" color="primary">Assign File</v-btn>
          </v-layout>

</v-layout>
        


      </v-card>

    </v-flex>
    <provider-selector-dialog ref="providerDialog" @emitProvider="addProvider($event)"></provider-selector-dialog>
    <file-dialog ref="fileDialog" />
    <advanced-patient-search-admin @emitPatient="selectPatient($event)" ref="patientSearchDialog"/>
  </v-layout>
</template>

<style lang="scss" scoped>
@import '../../../styles/form';

.table-border {
  border: 1px solid #e6e6e8;
}
.selectableCard {
  cursor: pointer;
  background-color: white;
  border: 1px solid #e6e6e8;
  border-radius: 4px;
}

.selectableCard:hover {
  background-color: #eeeeee;
}

.account-title {
  font-size: 24px;
  line-height: 30px;
  color: white;
}

.standardCard {
  border: 1px solid #e6e6e8;
  min-height: 200px;
}

.standardCard:hover {
  border: 1px solid #e6e6e8;
  background-color: rgb(251, 251, 251);
}

.file-card-text {
  font-size: 16px;
}

.file-card-title-text {
  font-size: 24px;
}

.headerTabUnselected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  opacity: 0.2;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}
.headerTabSelected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.headerTabUnselected:hover {
  opacity: 1;
}

</style>

<script>
import { mapActions, mapState } from 'vuex'
import Titlebar from '@/components/Titlebar'
import ProviderSelectorDialog from '@/components/dialogs/ProviderSelectorDialog'
import AdvancedPatientSearchAdmin from '@/components/dialogs/AdvancedPatientSearchAdmin'
import FileDialog from '@/components/dialogs/FileDialog'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import HelperMixin from '@/core/mixins/HelperMixin'
import bus from '@/core/helpers/bus'

export default {
  mixins: [HelperMixin],
  components: {
    Titlebar,
    ProviderSelectorDialog,
    vueDropzone: vue2Dropzone,
    FileDialog,
    AdvancedPatientSearchAdmin
  },
  data() {
    return {
      recordTypes: [
        'PRE_OP_NOTE',
        'POST_OP_NOTE',
        'OP_NOTE',
        'OFFICE_VISIT',
        'MESSAGE',
        'MRI',
        'IMAGE_READ',
        'XRAY',
        'OTHER_IMAGING',
        'LAB_RESULT',
        'PROGRESS_NOTE',
        'DIAGNOSTIC_REPORT',
        'REFERRAL',
        'COMPLETED_PRIOR_AUTH'
      ],
      typeInput: null,
      menuProvider: false,
      menuPatient: false,
      providerName: null,
      providerID: null,
      providerNameResult: null,
      date: null,
      encounterType: null,
      provider: null,
      patient: null,
      patientName: null,
      patientID: '',
      fileId: null,
      encounterTypes: [
        'PRE_OP_NOTE',
        'POST_OP_NOTE',
        'OP_NOTE',
        'OFFICE_VISIT',
        'MESSAGE',
        'MRI',
        'IMAGE_READ',
        'XRAY',
        'OTHER_IMAGING',
        'LAB_RESULT',
        'PROGRESS_NOTE',
        'DIAGNOSTIC_REPORT'
      ],
      files: null,
      optionalDescription: '',

      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 300,
        thumbnailHeight: 100,
        maxFilesize: 0.5,
        headers: { 'My-Awesome-Header': 'header value' }
      }
    }
  },
  methods: {
    ...mapActions('admin', [
      'getUploads',
      'getPatient',
      'getFile',
      'setFileInfo',
      'searchForPatient',
      'getProviderByID'
    ]),
    ...mapActions('provider', [
      'search',
      'getProviderIDFromNPI',
      'multipleShareFiles'
    ]),
    toast(type, text) {
      bus.$emit('toast', { type, text })
    },
    showPatientSearch() {
      this.$refs.patientSearchDialog.open({})
    },
    unixEncounterDate(date) {
      if (date !== '') {
        const formatDate =
          date.slice(4, 8) + '.' + date.slice(0, 2) + '.' + date.slice(2, 4)
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000
      }
    },
    convertDate(timestamp) {
      let d = new Date(timestamp * 1000)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    },
    adminHome() {
      this.$router.push({
        name: 'AdminLandingPage'
      })
    },
    documentsHome() {
      this.$router.push({
        name: 'AdminUploadsPage'
      })
    },
    uploadRecord() {
      let file = {}
      if (this.providerID) {
        file.renderingProvider = this.providerID
      }
      if (this.patientID) {
        file.patient = this.patientID
      }
      if (this.date) {
        file.encounterDate = this.unixEncounterDate(this.date)
      }
      if (this.typeInput) {
        file.recordType = this.typeInput
      }

      let vm = this
      this.setFileInfo({ file, id: this.file[0].id })
      vm.toast('success', 'File Assigned')
      this.$router.push({
        name: 'AdminUploadsPage'
      })
    },
    selectEncounterType(theType) {
      this.encounterType = theType
    },
    selectProvider(provider) {
      this.providerName =
        provider.displayNameIndividual + ' ' + provider.displayAddressIndividual
      this.getProviderIDFromNPI({ npis: [provider.npi] }).then(
        providerReturn => {
          let providerReturned = providerReturn[0]
          this.providerID = providerReturned._id
        }
      )
    },
    selectPatient(patient) {
      console.log('selected Patient')
      this.patientName = patient.firstName + ' ' + patient.lastName
      this.patientID = patient.id
    },
    showMoreInfo(upload) {
      this.getPatient({ id: upload.patient }).then(data => {
        const patient = data
        if (upload.provider) {
          this.getProviderAuth({ ids: upload.provider }).then(() => {
            const provider = this.providerAuthInfo

            this.$refs.uploadDialog.open({
              upload,
              provider,
              patient
            })
          })
        } else {
          this.$refs.uploadDialog.open({
            upload,
            patient
          })
        }
      })
    },
    openFile(file) {
      this.$refs.fileDialog.open({
        file
      })
    },
    searchPatient() {
      // Get rid of spaces
      const patientName = this.patientName.replace(/\s+/g, '')
      // Split out first and last name
      let patientTerms = patientName.split(',')

      if (patientTerms.length > 1) {
        // Capitialize the first and last name
        patientTerms[0] =
          patientTerms[0].charAt(0).toUpperCase() + patientTerms[0].slice(1)
        patientTerms[1] =
          patientTerms[1].charAt(0).toUpperCase() + patientTerms[1].slice(1)

        this.searchForPatient({
          firstName: patientTerms[1],
          lastName: patientTerms[0]
        })
      }
    },
    formatDate(timestamp) {
      let d = new Date(timestamp * 1000)
      let MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear()
      return MyDateString
    },
    patientHint() {
      if (this.patientID) {
        return this.patientID
      } else {
        return 'Format required: lastName,firstName'
      }
    },
    convertToUnix(date) {
      if (typeof date === 'number') {
        return date
      }

      if (date !== '') {
        const splitDate = date.toString().split('-')
        const formatDate =
          splitDate[0] + '.' + splitDate[1] + '.' + splitDate[2]
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000
      }
    }
  },
  computed: {
    ...mapState('admin', [
      'uploads',
      'patient',
      'upload',
      'file',
      'patientSearchResults'
    ]),
    ...mapState('provider', ['searchResults']),
    // TODO: Provider auth info?
    ...mapState('patient', ['providerAuthInfo']),
    ...mapState('auth', ['authToken']),
    patientName() {
      if (this.patient) {
        return this.provider._id
      }
      return ''
    }
  },
  created() {
    if (this.$route.query.file) {
      this.fileId = this.$route.query.file
      this.getFile(this.fileId).then(() => {
        let file = this.file[0]
        console.log(file)
        if (file.ocr) {
          var str = window.nlp(file.ocr).people().out('topk')
          console.log('NLP USAGE')
          console.log(str)
        }
        if (file.renderingProvider) {
          if (file.renderingProvider.firstName) {
            this.providerName = file.renderingProvider.firstName + ' ' + file.renderingProvider.lastName + ' ' + file.renderingProvider.credentials
          } else if (file.renderingProvider.organizationName) {
            this.providerName = this.providerDisplayNameFromProviderObject(file.renderingProvider)
          }
          this.providerID = file.renderingProvider.id
        }
        if (file.patient) {
          this.patientName =
            file.patient.firstName + ' ' + file.patient.lastName
          this.patientID = file.patient.id
        }
        if (file.encounterDate) {
          this.date = this.formatDate(file.encounterDate)
        }
        if (file.recordType) {
          this.typeInput = file.recordType
        }
      })
    }

    // this.getRequests()
    // this.getUploads()
  },
  // TODO:
  watch: {
    providerName(val) {
      this.search({ type: 'individual', terms: val })
    },
    request() {
      this.requests.find((r, i) => {
        if (r._id === this.request.id) {
          this.requests[i].status = this.request.status.status
          return true
        }
      })
    },
    patientName() {
      this.searchPatient()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/admin/AdminFileUploadPage.vue